/* eslint-disable sonarjs/no-duplicate-string */
import {
  LoyaltyGetRewardCardType,
  LoyaltyRewardCardBase,
  RewardCard,
} from "../types/Loyalty";
import url from "../url";

export enum LoyaltyTabs {
  REWARDS = "rewards",
  INFO = "info",
  AVATAR = "avatar",
}

export interface ILoyaltyInfoAwardsFake {
  id: number;
  img: string;
  title: string;
  features: string[];
}

export interface ILoyaltyInfoExclusiveFake {
  id: number;
  img: string;
  title: string;
}

export const LoyaltyInfoAwardsFake: ILoyaltyInfoAwardsFake[] = [
  {
    id: 1,
    img: "",
    title: "Start",
    features: [
      "Avatar skin",
      "Wager $5 - $100",
      "Includes 4 levels",
      "$5 cashback",
      "Get 11 free spins for this rank",
    ],
  },
  {
    id: 2,
    img: "",
    title: "Start",
    features: [
      "Avatar skin",
      "Wager $5 - $100",
      "Includes 4 levels",
      "$5 cashback",
      "Get 11 free spins for this rank",
    ],
  },
  {
    id: 3,
    img: "",
    title: "Start",
    features: [
      "Avatar skin",
      "Wager $5 - $100",
      "Includes 4 levels",
      "$5 cashback",
      "Get 11 free spins for this rank",
    ],
  },
  {
    id: 4,
    img: "",
    title: "Start",
    features: [
      "Avatar skin",
      "Wager $5 - $100",
      "Includes 4 levels",
      "$5 cashback",
      "Get 11 free spins for this rank",
    ],
  },
];

export const LoyaltyInfoExclusiveFake: ILoyaltyInfoExclusiveFake[] = [
  {
    id: 1,
    img: "",
    title: "Three types of cashback",
  },
  {
    id: 2,
    img: "",
    title: "Free spins and bonus money",
  },
  {
    id: 3,
    img: "",
    title: "Bonus on deposit every week",
  },
];

export const LoyaltyFAQ = [
  {
    id: 1,
    question: "How to get bonuses in the Loyalty Program?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 2,
    question: "What are ranks and levels?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 3,
    question: "What are kickbacks?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 4,
    question: "What is daily and weekly cashback?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 5,
    question: "What is a weekly deposit bonus?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 6,
    question: "What are free spins and bonus money?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 7,
    question: "What is an experience booster?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 8,
    question: "What is a custom avatar?",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
];

export const LoyaltyTermsAndConditions = [
  {
    id: 1,
    question: "Dates of the event",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 2,
    question: "Participation procedure",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 3,
    question: "Procedure",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
  {
    id: 4,
    question: "Rights and obligations of the Participant and the Organizer",
    answer:
      "The loyalty program is a system of rewards and bonuses for active players. The more you play, the more you get.",
  },
];

export const LOYALTY_ONBOARDING_DURATIONS = [
  { duration: 15000, isFinished: false, isProgress: true },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
];

export const LOYALTY_ONBOARDING_DURATIONS_MOBILE = [
  { duration: 15000, isFinished: false, isProgress: true },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
  { duration: 15000, isFinished: false, isProgress: false },
];

export const RANK_LEVEL_LOYALTY_IMAGES = [
  {
    name: "start",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/start.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/start-p-3.webp",
  },
  {
    name: "wood",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/wood.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/wood-p-3.webp",
  },
  {
    name: "stone",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/stone.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/stone-p-3.webp",
  },
  {
    name: "iron",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/iron.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/iron-p-3.webp",
  },
  {
    name: "brass",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/brass.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/bronze-p-3.webp",
  },
  {
    name: "silver",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/silver.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Silver-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/silver-p-3.webp",
  },
  {
    name: "ametyst",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/ametyst.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/amethyst-close-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/amethyst-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/amethyst-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/amethyst-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Amethyst-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Amethyst-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Amethyst-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Amethyst-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Amethyst-p-3.webp",
  },
  {
    name: "topaz",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/topaz.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/topaz-p-3.webp",
  },
  {
    name: "jade",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/jade.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/Jade-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/jade-p-3.webp",
  },
  {
    name: "obsidian",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/obsidian.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/obsidian-p-3.webp",
  },
  {
    name: "gold",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/gold.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/gold-p-3.webp",
  },
  {
    name: "pearl",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/pearl.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/pearl-p-3.webp",
  },
  {
    name: "saphire",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/saphire.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/saphire-p-3.webp",
  },
  {
    name: "emerald",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/emerald.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/emerald-p-3.webp",
  },
  {
    name: "ruby",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/ruby.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/ruby-p-3.webp",
  },
  {
    name: "diamond",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/diamond.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/diamond-p-3.webp",
  },
  {
    name: "platinum",
    rank: "https://diswdgcu9cfva.cloudfront.net/loyalty/ranks/platinum.webp",
    close1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-closed-1.webp",
    close2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-closed-2.webp",
    close3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-closed-3.webp",
    empty1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/hz-empty-1.webp",
    empty2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-empty-2.webp",
    empty3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-empty-3.webp",
    progress1:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-p-1.webp",
    progress2:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-p-2.webp",
    progress3:
      "https://diswdgcu9cfva.cloudfront.net/loyalty/chest/platinum-p-3.webp",
  },
];

export const KEYS_REWARD_BONUS_ECOSYSTEM = [
  "rewardFreeSpinId",
  "rewardNominalId",
];

export const LOYALTY_GET_REWARD_CARD_LIST: LoyaltyGetRewardCardType[] = [
  {
    id: 1,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/slot-machine.webp",

    title: "loyalty.reward.experience.title",
    desc: "loyalty.reward.experience.desc",
    type: RewardCard.EXPERIENCE,
    buttonText: "loyalty.reward.experience.btn",
  },
  {
    id: 2,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/rocket.webp",
    title: "loyalty.reward.bonus.title",
    desc: "loyalty.reward.bonus.desc",
    type: RewardCard.BONUS,
    buttonText: "loyalty.btn.myBonuses",
    url: url.routes.profile.bonus(),
  },
];

export const LOYALTY_MORE_REWARD_CARD_LIST: LoyaltyRewardCardBase[] = [
  {
    id: 1,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/wallet.webp",
    title: "loyalty.more.reward.bonus.title",
    desc: "loyalty.more.reward.bonus.desc",
  },
  {
    id: 2,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/cashback.webp",
    title: "loyalty.more.reward.cashback.title",
    desc: "loyalty.more.reward.cashback.desc",
  },
  {
    id: 3,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/slots.webp",
    title: "loyalty.more.reward.freespins.title",
    desc: "loyalty.more.reward.freespins.desc",
  },
  {
    id: 4,
    img: "https://diswdgcu9cfva.cloudfront.net/loyalty/reward/avatar.webp",
    title: "loyalty.more.reward.skins.title",
    desc: "loyalty.reward.bonus.desc",
  },
];
